import {useEffect, useState} from "react";
import Loading from "../../../component/Loading/Loading";
import {base64DecodeUnicode} from "../../../assets/functions";
import {getManagerHeader} from "../../Login/functions";
import axios from "axios";
import {baseCmsApiUrl} from "../../../assets/Constants";
import OrderForm from "../component/OrderForm";

const AddOrder = () => {

    const [isLoading, setIsLoading] = useState(true);
    const billItem = {
        singleProductId: "",
        count: "",
        payType: "CASH",
        priceRate: "",
        prepayedAmount: "",
        numberOfInstallment: "",
        refundMethod: "MONTHLY",
        priceId: "",
        price: {
            currency : {
                id : 1,
                name : "تومان",
                rate : 1
            },
            amount: "",
            discountAmount: "",
            discountPercent: "",
            isClosed: "",
            closedRate: "",
            minimumRate: ""
        },
        installmentHistories: [],
        isPayed : true,
        isDelivered : false,


    };
    const [bill, setBill] = useState({
        customerId: "",
        addressId: "",
        discountCodeId: "",
        deliveryAmount: "",
        deliveryTimestamp : Math.round(+new Date() / 1000),
        billItems: [],
        isVerified : true,
        isPayed : true,
        discountAmountWithDiscountCode : 0,
    });
    const handleSubmit = async () => {
        setIsLoading(true);
        const headers = getManagerHeader();
        axios.post(baseCmsApiUrl + 'bills', bill, {headers})
            .then((response) => {
                console.log(response);
                console.log(response.data);
                // toastSuccess(base64DecodeUnicode(response.statusText));
                // navigate("/orders");
                return;
            })
            .catch((e) => {
                console.error(e)
                console.log(base64DecodeUnicode(e.response.statusText))
                console.log(e.response.data)
            }).finally(() => {
            setIsLoading(false)
        })
    }

    useEffect(() => {
        (async () => {
            document.title = "ایجاد فاکتور";
            setIsLoading(false);
        })();
    }, []);


    if (isLoading)
        return <Loading/>


    return (<div className="container-fluid p-0">
        <div className="mb-4">
            <h1 className="h3 d-inline align-middle">ایجاد فاکتور</h1>
        </div>

        <OrderForm bill={bill} onChange={(value) => {
            console.log(value);
            setBill(value)
        }} />

        <div className="col-12 mt-3">
            <button type={"button"} className={"btn btn-success w-100"} disabled={isLoading}
                    onClick={handleSubmit}>ایجاد فاکتور
            </button>
        </div>

    </div>);
}

export default AddOrder;